const axios = require("axios");

var getNganhs = (dotDangKyId) => {
	return axios
		.get(`${process.env.VUE_APP_API}${process.env.VUE_APP_NGANH}/duocdk/${dotDangKyId}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			return error.response;
		});
};

var createNganh = (payload) => {
	return axios
		.post(`${process.env.VUE_APP_API}${process.env.VUE_APP_NGANH}`, {
			maNganh: payload.maNganh,
			tenNganh: payload.tenNganh,
			chiTieuHb: payload.chiTieuHb,
			chiTieuThpt: payload.chiTieuThpt,
		})
		.then((response) => {
			return response;
		})
		.catch((error) => {
			return error.response;
		});
};

var updateNganh = (payload) => {
	return axios
		.put(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_NGANH}/${payload.id}`,
			{
				maNganh: payload.maNganh,
				tenNganh: payload.tenNganh,
				chiTieuHb: payload.chiTieuHb,
				chiTieuThpt: payload.chiTieuThpt,
			},
		)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			return error.response;
		});
};

var deleteNganh = (id) => {
	return axios
		.delete(`${process.env.VUE_APP_API}${process.env.VUE_APP_NGANH}/${id}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			return error.message;
		});
};

export const NganhService = {
	getNganhs,
	createNganh,
	updateNganh,
	deleteNganh,
};
